import React from 'react';
import { Menu, Tooltip } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';
import { useUpgradeModal } from '../contexts/UpgradeModalContext';

interface Props {
  featureCode: string;
  label: string;
  menuKey: string;
  to: string;
  icon?: React.ReactNode;
}

const FeatureMenuItem: React.FC<Props> = ({ featureCode, label, menuKey, to, icon }) => {
  const { hasFeature, appReady, currentPlan } = useAppContext();
  const { openUpgradeModal } = useUpgradeModal();

  const isLocked = appReady && !hasFeature(featureCode);

  if (!isLocked) {
    return (
      <Menu.Item key={menuKey} icon={icon}>
        <Link to={to}>{label}</Link>
      </Menu.Item>
    );
  }

  return (
    <Menu.Item
      key={menuKey}
      title={label}
      icon={icon ? <span style={{ opacity: 0.45 }}>{icon}</span> : undefined}
      onClick={() => openUpgradeModal({ feature: featureCode, currentPlan })}
      style={{ opacity: 0.5, cursor: 'pointer' }}
    >
      <Tooltip title="Upgrade your plan to unlock this feature" placement="right">
        <span style={{ display: 'inline-flex', alignItems: 'center', width: '100%', gap: 6, minWidth: 0 }}>
          <span
            style={{
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </span>
          <LockOutlined style={{ fontSize: 11, color: '#9CA3AF', flexShrink: 0 }} />
        </span>
      </Tooltip>
    </Menu.Item>
  );
};

export default FeatureMenuItem;
